import FailedIdentityProviderSignup from './FailedIdentityProviderSignup';

export default FailedIdentityProviderSignup;
